import { RenderFunc } from '../types/RenderFunc';
import { KnmHistoryOperationsEnum } from '../../../APIPackage/KnmModule/enums/KnmHistoryOperationsEnum';

export const renderAccessPrivilegeOrganisation: RenderFunc = item => {
  const { newValue, oldValue, operation } = item;
  let changeText;

  switch (operation) {
    case KnmHistoryOperationsEnum.INSERT:
      changeText = `Доступ к мероприятию добавлен "${newValue}"`;
      break;
    case KnmHistoryOperationsEnum.DELETE:
      changeText = `Доступ к мероприятию удален "${oldValue}"`;
      break;
    default:
  }

  return {
    renderedOldValue: `${oldValue}`,
    renderedNewValue: `${newValue}`,
    renderedChangeText: changeText,
  };
};
